<template>
  <div class="animated fadeIn">
    <vue-headful :title="`Lista Formularzy`" />
    <b-row>
      <b-col md="7">
        <b-col md="12">
          <b-card>
            <div slot="header">
              <strong>Filtry</strong>
            </div>
            <b-form inline class="filter-form">
              <b-input :class="(filters.formName) ? `filled-filter` : ``" id="title" type="text" placeholder="Nazwa formularza" v-model="filters.formName"></b-input>
              <label class="mx-sm-2" for="project">Projekt: </label>
              <b-form-select :class="(filters.projectId !== -1) ? `filled-filter` : ``" id="project" :plain="true"
                             :options="projectsOptions" v-model="filters.projectId">
              </b-form-select>
              <label class="mx-sm-2" for="status">Status: </label>
              <b-form-select id="status" :plain="true" :options="statusOptions" v-model="filters.status">
              </b-form-select>
              <label class="mx-sm-2"></label>
              <b-button variant="primary" @click="filters = defaultFilter()"><i class="fa fa-times"></i> Wyczyść</b-button>
            </b-form>
          </b-card>
        </b-col>
        <b-col md="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i> <strong>Formularze</strong>
              <small class="float-right">
                <b-button type="button" variant="btn btn-primary" @click="createFormModal = true" title="Dodaj formularz">
                  <i class="fa fa-plus"></i>&nbsp; Dodaj
                </b-button>
              </small>
            </div>
            <b-col md="12" v-if="loading">
              <div class="loading" >Loading...</div>
            </b-col>
            <div v-else-if="forms.data.length > 0" class="scrollable-list">
              <b-list-group :key="index" v-for="(form, index) in forms.data">
                  <b-list-group-item :variant="(currentForm && form.formName === currentForm.formName) ? `primary` : ``" class="flex-column align-items-start cursor-pointer" @click="getSingleForm(form)">
                    <div class="d-flex w-100 justify-content-between">
                      <span>
                        <b-badge class="badge-blue"><span> {{ form.projectName }} </span></b-badge>
                        <router-link :to="{name: 'forms-single', params: { formId: form.id }}">
                          <span :style="form.active ? `` : `color: grey`" class="cursor-pointer font-xl">{{ form.formName }}</span>
                        </router-link>
                      </span>
                      <span>
                        <b-button type="button" variant="primary-outline" @click="duplicateFormModal = true" title="Duplikuj"><i class="fa fa-copy"></i></b-button>
                      </span>
                    </div>
                    <p class="mb-1">
                      <span>
                        <i v-if="form.thankYouPageUrl && form.thankYouPageUrl !== ''" class="text-success fa fa-globe" :title="'Strona podziękowań: ' + form.thankYouPageUrl"></i>
                        <i v-else class="text-danger fa fa-globe" title="Strona podziękowań nie jest ustawiona"></i>
                      </span> |
                      <span v-for="notification in form.notifications.email" :key="'NE'+notification.id">
                        <span v-for="(recipient, j) in notification.recipients" :key="'R'+j">
                          <b-badge class="badge" :variant="notification.status === 'ACTIVE' ? 'success' : 'warning'"><i class="fa fa-envelope"></i> {{ recipient }}</b-badge> |
                        </span>
                      </span>
                      <span v-for="notification in form.notifications.sms" :key="'NS'+notification.id">
                          <b-badge class="badge" :variant="notification.status === 'ACTIVE' ? 'success' : 'warning'"><i class="fa fa-mobile-phone"></i> {{ notification.recipient }}</b-badge> |
                      </span>
                    </p>
                  </b-list-group-item>
              </b-list-group>
            </div>
            <div v-else><i>Brak formularzy</i></div>
            <div class="show-more-box" v-if="forms.showMore">
              <button class="btn btn-outline-primary float-right" href="#" v-on:click="paginateForms()">więcej</button>
            </div>
          </b-card>
        </b-col>

      </b-col>
      <b-col md="5" v-if="currentForm" style="position: sticky; top: 0;">
        <b-col md="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i> <strong>Podgląd</strong>
              <small class="float-right">
                <b-button type="button" variant="btn btn-primary" @click="editFormModal = true" title="Edytuj formularz">
                  <i class="fa fa-pencil"></i>&nbsp; Edytuj
                </b-button>
              </small>
            </div>
            <c-form-full-overview :form="currentForm"></c-form-full-overview>
            <div slot="footer">
              <b-button v-if="currentForm.active" class="float-right" variant="danger" @click="remove(currentForm)">Usuń</b-button>
              <b-button v-else class="float-right" variant="primary" @click="restore(currentForm)">Przywróć</b-button>
            </div>
          </b-card>
        </b-col>
      </b-col>
    </b-row>
    <b-modal size="lg" hide-footer no-footer title="Nowy formularz" class="modal-primary" v-model="createFormModal">
      <c-form-creator :projects="projects" @saved="createForm"></c-form-creator>
    </b-modal>
    <b-modal v-if="currentForm" size="lg" hide-footer no-footer :title="`Edycja ` + currentForm.formName" class="modal-primary" v-model="editFormModal">
      <c-form-creator :projects="projects" :init-form="currentForm" @saved="editForm"></c-form-creator>
    </b-modal>
    <b-modal v-if="currentForm" size="lg" hide-footer no-footer :title="`Kopiowanie ` + currentForm.formName" class="modal-primary" v-model="duplicateFormModal">
      <div>
        <b-row>
          <b-col md="6">
            <p><strong>Nazwa:</strong> <b-form-input v-model="duplicatedForm.formName" /></p>
          </b-col>
          <b-col md="6">
            <p><strong>Projekt:</strong><b-form-select id="project" :plain="true" :options="projectsOptions" v-model="duplicatedForm.projectId" /></p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <i class="text-black-50">Skopiowane zostaną wszystkie ustawienia formularza <b>{{ currentForm.formName}}</b> w tym powiadomienia i webhooki</i>
          </b-col>
        </b-row>
        <hr/>
        <b-button variant="primary" class="float-right" @click="createDuplicatedForm()">Utwórz</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import leadsClient from '../../service/leadsClient'
import vueHeadful from 'vue-headful'
import CFormFullOverview from '../../components/Form/FormFullOverview'
import CFormCreator from '../../components/Form/FormCreator'
import storage from '../../components/storage'
import paginator from '../../components/paginator'
import projectHelper from '../../components/Project/projectHelper'

const LIMIT = 25

export default {
  name: 'forms-list',
  components: {
    vueHeadful,
    CFormFullOverview,
    CFormCreator
  },
  data () {
    return {
      loading: false,
      forms: paginator.method.defaultObject(),
      projects: null,
      projectsOptions: [],
      statusOptions: [
        { text: 'Aktywne', value: 1 },
        { text: 'Nieaktywne', value: 0 }
      ],
      editMode: false,
      createFormModal: false,
      editFormModal: false,
      filters: this.defaultFilter(),
      awaitingFilters: false,
      currentForm: null,
      duplicateFormModal: false,
      duplicatedForm: { formName: null, projectId: -1 },
      limit: '15',
      offset: '0'
    }
  },
  created () {
    this.filters = this.loadFiltersFromStorage()
  },
  mounted () {
    this.getProjects()
  },
  watch: {
    filters: {
      deep: true,
      async handler (filters) {
        const savedFilters = this.loadFiltersFromStorage()
        const nameChanged = savedFilters.formName !== filters.formName
        this.saveFiltersToStorage()
        if (nameChanged) {
          await this.postponeRefreshForms()
        } else {
          await this.refreshForms()
        }
      }
    }
  },
  methods: {
    async paginateForms () {
      this.loading = true
      try {
        const forms = await leadsClient.getForms((LIMIT + 1), this.forms.offset, this.filters)
        paginator.method.pagination(this, 'forms', forms)
      } finally {
        this.loading = false
      }
    },
    async refreshForms () {
      this.loading = true
      try {
        const data = await leadsClient.getForms((LIMIT + 1), 0, this.filters)
        this.forms = paginator.method.defaultObject()
        this.forms.limit = LIMIT
        paginator.method.pagination(this, 'forms', data)
      } finally {
        this.loading = false
      }
    },
    async postponeRefreshForms () {
      if (!this.awaitingFilters) {
        setTimeout(() => {
          this.refreshForms()
          this.awaitingFilters = false
        }, 300)
      }
      this.awaitingFilters = true
    },
    async createForm (form) {
      await leadsClient.createForm(form)
      this.createFormModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Dodano formularz', text: '' })
      await this.refreshForms()
    },
    async editForm (form) {
      await leadsClient.editForm(form)
      this.editFormModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Zapisano zmiany', text: '' })
      await this.refreshForms()
    },
    async remove (form) {
      await this.$confirm('Czy na pewno chcesz usunąć formularz ' + form.formName + '?', '', '', { confirmButtonText: 'Tak', cancelButtonText: 'Nie' })
      await leadsClient.disableForm(form.id)
      await this.refreshForms()
      this.currentForm = null
    },
    async restore (form) {
      await leadsClient.enableForm(form.id)
      await this.refreshForms()
      this.currentForm = null
    },
    saveFiltersToStorage () {
      storage.set('formsFilters', this.filters)
    },
    loadFiltersFromStorage () {
      return storage.get('formsFilters', this.defaultFilter())
    },
    defaultFilter () {
      return {
        formName: '',
        projectId: -1,
        status: 1
      }
    },
    async getProjects () {
      this.projects = await leadsClient.getProjects(999, 0)
      this.projectsOptions = projectHelper.getProjectOptions(this.projects)
    },
    async getSingleForm (form) {
      this.currentForm = await leadsClient.getForm(form.id)
      this.duplicatedForm = JSON.parse(JSON.stringify(this.currentForm))
      this.duplicatedForm.formName = null
    },
    async createDuplicatedForm () {
      const formId = await leadsClient.createForm(this.duplicatedForm)
      const promises = []
      this.duplicatedForm.notifications.sms.forEach(notification => {
        promises.push(leadsClient.createSmsNotification(formId, notification))
      })
      this.duplicatedForm.notifications.email.forEach(notification => {
        promises.push(leadsClient.createEmailNotification(formId, notification))
      })
      this.duplicatedForm.webhooks.forEach(webhook => {
        promises.push(leadsClient.createWebhook(formId, webhook))
      })
      await Promise.all(promises)
      await this.refreshForms()
      this.duplicateFormModal = false
    }
  }
}
</script>
